import { data } from '../../svg/Paragraph/data';
import { makeIcon } from '../makeIcon';

export const Paragraph = makeIcon(data, 'paragraph', 'Paragraph');

export default Paragraph;
